
const header_experiment_config = [
    {   
        id:"Participant_ID", title : "Participant ID", inputType:"select-participant" , 
        description:"Select Participants ID from the dropdown list.", 
        mandatory:true, selection : [], width :200
    },
    {   
        id:"Experiment", title : "Local Experiment ID", inputType:"text", 
        description:"The local ID you use to identify the experiment you are submitting.", 
        mandatory:true, selection : [], width :250
    },
    {   
        id:"Projects", title : "Project", inputType:"selectMultiple", 
        description:"Please select to which project the sample belongs. If it doesn't belong to any specific project, please select RD-Connect", 
        mandatory:true, selection : [], width :220
    },
    {   
        id:"months", title : "Embargo length", inputType:"select", 
        description:"Please select the number of months you would like for this experiment to be private to your group.", 
        mandatory:true, selection : ["----","0","1","2","3","4","5","6"], width :140
    },
    {
        id: "long_term_storage", title: "EGA long term storage", inputType: "select",
        description:"Can your dataset be archived at the European Genome-Phenome Archive (EGA) under controlled access as part of the ERDERA study?",
        mandatory:true, selection : ['----', "YES", "NO"],  width: 200
    },
    {   
        id:"erns", title : "ERNs", inputType:"select", description:"", mandatory:true,
        selection : [], width:220
    },
    {   
        id:"tissues", title : "Tissue", inputType:"select", description:"Select a tissue type.", mandatory:true,
        selection : [], width:330
    },
    {   
        id:"LibraryStrategy", title : "Library Strategy", inputType:"select", description:"", mandatory:true,
        selection : ["----","WGS","WXS","RNA-seq", "LR-WGS", "OGM"], width :130
    },
    {   
        id:"kits", title : "Protocol/Exome Kit", inputType:"select", description:"", mandatory:true,
        selection : [], width :360
    },
    {   
        id:"EGA", title : "EGA ID", inputType:"text", 
        description:"If ou have already submitted data to the EGA, please provide EGA sample ID.", mandatory:false,
        selection : [], width :250
    },
    {   
        id:"LibraryIsize", title : "Library Insert Size", inputType:"number", 
        description:"Set the average Insert Size of the library.", mandatory:false,
        selection : [], width :220
    }
];

export default header_experiment_config;
